import { chartColors, optionsStackedBar } from "./utils"

// Stacked bar chart
const spotlight_figure_1 = {
  type: "stacked",
  figureNumber: "1.1",
  title: "IMF Financial Support ",
  subTitle: "(cumulative, billions of US dollars)",
  caption: "IMF lending has provided countries much-needed liquidity support.",
  source: "Sources: IMF, Finance Department; and IMF, Strategy, Policy and Review Department./n Note: As of April 30, 2022. FCL = Flexible Credit Line; PLL = Precautionary and Liquidity Line; RCF = Rapid Credit Facility; RFI = Rapid Financing Instrument. /n * Indicates both new programs and augmentation of existing programs.",
  data: {
    labels: [
      "Apr-20",
      "Jul-20",
      "Nov-20",
      "Jul-21",
      "Nov-21",
      "Mar-22",
      "Apr-22",
    ],
    datasets: [
      {
        label: "Upper-Credit Tranche*",
        borderColor: chartColors(1),
        backgroundColor: chartColors(1),
        data: [
          1.839752515, 2.809570295, 10.46881944, 22.23053701, 22.44374281,
          79.5024472, 79.5024472,
        ],
        barThickness: 12,
      },
      {
        label: "RCF, RFI or RCF-RFI blends",
        borderColor: chartColors(0),
        backgroundColor: chartColors(0),
        data: [
          14.14890183, 28.23419403, 28.73059963, 29.81843108, 30.52085853,
          31.91235018, 31.91235018,
        ],
        barThickness: 12,
      },
      {
        label: "FCL and PLL",
        borderColor: chartColors(2),
        backgroundColor: chartColors(2),
        data: [
          0, 45.67830029, 51.87794449, 54.59071609, 104.4490729, 104.4490729,
          114.0685729,
        ],
        barThickness: 12,
      },
    ],
  },
  options: optionsStackedBar,
}

export default spotlight_figure_1;
